import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';
import type {OnboardingPageType} from 'shells/onboarding-modal/onboarding-modal';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import {ChatWidgetOpensPage} from './pages/chat-widget-opens';
import {CompletedActionsPage} from './pages/completed-actions';
import {LeadsCreatedPage} from './pages/leads-created';
import {SalesGeneratedPage} from './pages/sales-generated';
import {UniqueVisitorsPage} from './pages/unique-visitors';

export function EngagementReportOnboardingModal() {
    const {isOpen, onClose} = useOpenableModal(OpenableModals.ENGAGEMENT_REPORT_ONBOARDING_MODAL);

    const pages: OnboardingPageType[] = [
        {
            id: 'unique-visitors',
            body: <UniqueVisitorsPage />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={<Illustration src='engagement-report-onboarding/unique-visitors' />}
                        width={400}
                        noPadding={true}
                    />
                ),
            },
        },
        {
            id: 'chat-widget-opens',
            body: <ChatWidgetOpensPage />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={
                            <Illustration
                                src='engagement-report-onboarding/chat-widget-opens'
                                width={330}
                            />
                        }
                        width={330}
                    />
                ),
            },
        },
        {
            id: 'completed-actions',
            body: <CompletedActionsPage />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={
                            <Illustration
                                src='engagement-report-onboarding/completed-actions'
                                width={330}
                            />
                        }
                        width={330}
                    />
                ),
            },
        },
        {
            id: 'leads-created',
            body: <LeadsCreatedPage />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={
                            <Illustration
                                src='engagement-report-onboarding/leads-created'
                                width={330}
                            />
                        }
                        width={330}
                    />
                ),
            },
        },
        {
            id: 'sales-generated',
            body: <SalesGeneratedPage />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <ImageWrapper
                        image={
                            <Illustration
                                src='engagement-report-onboarding/sales-generated'
                                width={330}
                            />
                        }
                        width={330}
                    />
                ),
            },
        },
    ];

    return (
        isOpen && (
            <OnboardingModal
                trapFocus={false}
                lastButtonText='Done'
                pages={pages}
                onClose={onClose}
                onFinish={onClose}
                canClickOutsideToClose={false}
            />
        )
    );
}
